module.exports = __webpack_public_path__ + "static/media/TAGGIS-Promo.cf2ade18.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/TAGGIS-Promo.pdf
// module id = 466
// module chunks = 3